/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-unused-vars: 0, no-use-before-define: 0, no-var: 0 */
/* globals _, mp */

/*
 * Provides:
 *  mp.widgets.Calendar
 *
 * Requires:
 *  date.js
 *  mp.widgets.Dropdown
 *  jquery ui calendar
 */

_.namespace(`mp.widgets`, function(ns) {
  'use strict';
  function Calendar() {
    this.class_name = `calendar`;
    this.body_class = Body;
    this.label_class = Label;
  }
  _.inherit(Calendar, mp.widgets.Dropdown);

  Calendar.prototype.default_config = function() {
    return _.extend(
      Calendar.superclass.default_config.call(this), {
        collapse: true,
        emulate_select: true,
        num_months: 2,
        max_date: `+0`,
        min_date: null,
      });
  };

  Calendar.prototype.set_date = function(date, skip_event) {
    if (!(date instanceof Date) || _.isNaN(date.valueOf())) {
      throw new Error(`Calendar.set_date called with non-Date`);
    }
    var item = new Item().create().update(date);
    this.selected_date = date;
    this.label.select(item, skip_event);
    this.body.set_date(date, skip_event);
  };

  Calendar.prototype.set_option = function(option, value) {
    this.body.calendar.datepicker(`option`, option, value);
  };

  Calendar.prototype.deactivate = function(ev) {
    // Datepicker element seems to be removed from the flow of the page and
    // we can't tell clicks inside it from clicks outside.
    // So, only deactivate if click was not inside.
    if (!$(ev.target).closest(`.ui-datepicker-header`).length) {
      Calendar.superclass.deactivate.call(this);
    }
  };

  function Label() {
    this.class_name = `label`;
  }
  _.inherit(Label, mp.widgets.Dropdown.Label);

  Label.prototype.create = function(div, config) {
    Label.superclass.create.call(this, div, config);
    return this;
  };

  Label.prototype.select = function(item, skip_event) {
    if (typeof(item) === `string`) { // we were called by base Dropdown.create (hopefully)
      return this;
    }
    this.value = item.val();
    this._set_content(this.value);
    if (!skip_event) {
      this.container.trigger(`label-changed`, this);
    }
    return this;
  };

  Label.prototype._set_content = function(date) {
    this.title.text(date.toString(`MMM dS, yyyy`));
  };


  function Body() {
    this.class_name = `body`;
  }
  _.inherit(Body, mp.widgets.Dropdown.Body);

  Body.prototype.create = function(div, config) {
    Body.superclass.create.call(this, div, config);
    return this;
  };

  Body.prototype.fill = function() {
    var datepicker_config = _.extend({
      altFormat: `yy-mm-dd`,
      beforeShowDay: mp.utility.feature_gate_datepicker,
      dayNamesMin: [`S`, `M`, `T`, `W`, `T`, `F`, `S`],
      defaultDate: null,
      numberOfMonths: this.config.num_months,
      maxDate: this.config.max_date,
      minDate: this.config.min_date,
      onSelect: _.bind(function(date_text, inst) {
        var item = new Item().create().update(Date.parse(date_text));
        if (!this.skip_event) {
          this.container.trigger(`dropdown-item-selected`, [item]);
        }
      }, this),
    }, this.datepicker_options());
    this.calendar = $(`<div>`).addClass(`cal`);
    this.calendar.datepicker(datepicker_config);
    var triangle = $(`<div>`).addClass(`triangle`).append($(`<div>`));
    this.container.append(this.calendar, triangle);
    mp.utility.maybe_add_feature_gate_upsell_to_calendar(this.container);
    return this;
  };

  Body.prototype.datepicker_options = function() {
    return {};
  };

  Body.prototype.set_date = function(date, skip_event) {
    var cal_date = this.calendar.datepicker(`getDate`);
    if (date !== cal_date) {
      // set a global skip flag temporarily
      var prev_skip = this.skip_event;
      this.skip_event = skip_event;
      this.calendar.datepicker(`setDate`, date);
      this.skip_event = prev_skip;
    }
  };

  Body.prototype.activate = function(fire_event, label) {
    if (Body.superclass.activate.apply(this, arguments)) {
      if (_.isUndefined(this._initial_cal_left)) {
        // remember the initial left position so we know whether
        // to right-align to left-align the calendar
        this._initial_cal_left = $(this.container).offset().left;
      }

      var label_width = label.container.outerWidth();
      var cal_width = this.container.outerWidth();
      var cal_left = this._initial_cal_left;
      var cal_right = cal_left + cal_width;
      var $container = $(`#report_content`).length ? $(`#report_content`) : $(`body`);
      var report_edge = $container.width() + $container.offset().left;

      var left = 0;
      var triangle_left = label_width / 2 - 8; // subtract half triangle width

      if (report_edge < cal_right && report_edge > cal_width) {
        // right-align the calendar to keep it on screen
        left = - cal_width + label_width;
        triangle_left -= left;
      }
      this.container.css(`left`, left + `px`);

      var triangle = $(`.triangle`, this.container);
      triangle.css(`left`, triangle_left + `px`);
      return this;
    }
  };


  function Item(value) {
    this.value = value;
  }
  _.inherit(Item, mp.widgets.Dropdown.Item);
  Item.prototype.val = function() {
    return this.value;
  };

  Calendar.Body = Body;
  Calendar.Label = Label;
  Calendar.Item = Item;
  return {
    Calendar,
  };
});

}.call(window));